<template>
  <div class="node-style">
    <Button
      class="edit"
      icon="md-add"
      :type="type"
      shape="circle"
      @click="handleClick()"
    ></Button>
    <p>{{title}}</p>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '普通节点'
    },
    type: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick() {
      this.$emit('click')
    }
  }
}
</script>